import "./index.css";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { LoadingProvider } from "./context/LoadingContext";
import { AuthProvider } from "./context/AuthContext";
import reportWebVitals from "./reportWebVitals";
import RoutesComponent from "./Routes";

const root = document.getElementById("root");
ReactDOM.createRoot(root as HTMLElement).render(
  <BrowserRouter basename="/surfr-ui/">
    <LoadingProvider>
      <AuthProvider>
        <RoutesComponent />
        {/* App-wide toast host. Was missing entirely, so every toast.* across the app
            rendered nothing. zIndex sits above modals (z-[9999]) so error toasts shown
            from inside a modal are visible. */}
        <ToastContainer position="top-right" autoClose={4000} style={{ zIndex: 100000 }} />
      </AuthProvider>
    </LoadingProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
